import { render } from "./index.vue?vue&type=template&id=950dc2ec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/banners-edit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "950dc2ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('950dc2ec', __exports__)) {
    api.reload('950dc2ec', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=950dc2ec", () => {
    api.rerender('950dc2ec', render)
  })

}


export default __exports__